// extracted by mini-css-extract-plugin
export default {"searchWrapper":"SearchBar_searchWrapper__wP6oT","searchIcon":"SearchBar_searchIcon__6Et+r","searchInput":"SearchBar_searchInput__vuyLt","clearSearch":"SearchBar_clearSearch__JVF8x"};